var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Prop, Emit, Model } from "vue-property-decorator";
import { PaybackType, QueryDateType } from './dashboard.config';
import ChartDateSelect from "./chart-date-select.vue";
import { ProductService } from '~/services/domain-service/product.service';
import { Dependencies } from "~/core/decorator";
var ChartQueryForm = /** @class */ (function (_super) {
    __extends(ChartQueryForm, _super);
    function ChartQueryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.paybackType = PaybackType;
        _this.queryDateType = QueryDateType;
        _this.pullDownData = [];
        return _this;
    }
    ChartQueryForm.prototype.emitQueryModel = function (value) { };
    /**
     * 下拉
     */
    ChartQueryForm.prototype.pullDown = function () {
        var _this = this;
        this.productService.selectProductList().subscribe(function (data) {
            _this.pullDownData = data;
            _this.qureyDataChange();
        });
    };
    ChartQueryForm.prototype.qureyDataChange = function () {
        this.emitQueryModel(__assign({}, this.queryModel));
    };
    ChartQueryForm.prototype.mounted = function () {
        this.pullDown();
    };
    __decorate([
        Dependencies(ProductService)
    ], ChartQueryForm.prototype, "productService", void 0);
    __decorate([
        Prop({
            default: false
        })
    ], ChartQueryForm.prototype, "hiddenDateType", void 0);
    __decorate([
        Model("update-query")
    ], ChartQueryForm.prototype, "queryModel", void 0);
    __decorate([
        Emit("update-query")
    ], ChartQueryForm.prototype, "emitQueryModel", null);
    ChartQueryForm = __decorate([
        Component({
            components: {
                ChartDateSelect: ChartDateSelect
            }
        })
    ], ChartQueryForm);
    return ChartQueryForm;
}(Vue));
export default ChartQueryForm;
